
  document.addEventListener('DOMContentLoaded', function () {

    const target = document.querySelector('.a.iWishAddColl');

    if (!target) return;

    // Make sure it is focusable
    if (!target.hasAttribute('tabindex')) {
        target.setAttribute('tabindex', '0');
    }

    // Move focus to it
    target.focus();

});

  function drawerInitCallback() {

    const drawer = document.querySelector('#iwish-drawer-root');
    if (!drawer) return;

    setTimeout(() => {

        if (drawer.offsetParent === null) return;

        enableSvgFocus(drawer);
        trapFocus(drawer);

    }, 300);
}

function enableSvgFocus(drawer) {

    const clickableSpans = drawer.querySelectorAll(
        '.iconActionCol span, ' +
        '.mst-drawer-title-icon, ' +
        '.transferProducts, ' +
        '.editBtn, ' +
        '.minusQty, ' +
        '.plusQty, ' +
        '#dropdown-basic, ' +
        '.dropdown-item, ' +
        '.iWishAddColl, ' +
        '.sc-dIMoHT, ' +
        '.t-center'
    );

    clickableSpans.forEach(el => {

        if (!el.hasAttribute('tabindex')) {
            el.setAttribute('tabindex', '0');
        }

        el.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                el.click();
            }
        });

    });
}

function trapFocus(drawer) {

    const focusableSelectors = `
        .iconActionCol span,
        a[href],
        button:not([disabled]),
        input:not([disabled]),
        select,
        textarea,
        [tabindex="0"],
        .dropdown-item,
        .iWishAddColl
    `;

    const focusableElements = drawer.querySelectorAll(focusableSelectors);

    if (!focusableElements.length) return;

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    firstElement.focus();

    drawer.addEventListener('keydown', function (e) {

        if (e.key !== 'Tab') return;

        if (e.shiftKey) {

            if (document.activeElement === firstElement) {
                e.preventDefault();
                lastElement.focus();
            }

        } else {

            if (document.activeElement === lastElement) {
                e.preventDefault();
                firstElement.focus();
            }

        }

    });
}
